import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-selection-modal',
  templateUrl: './selection-modal.component.html',
  styleUrls: ['./selection-modal.component.scss']
})
export class SelectionModalComponent implements OnInit {

  data!: any;

  constructor() { }

  ngOnInit(): void {
    console.log(this.data);
  }

}
